export default {
  // 租赁合同列表
  LEASE_CONTRACT_LIST_PAGE: '/property/leaseContract',
  LEASE_CONTRACT_LIST_PAGE_V2: '/property/leaseContract/page/v2',
  // 关闭租赁合同
  CLOSE_LEASE_CONTRACT: '/property/leaseContract/close',
  // 关联合同
  RELATE_CONTRACT: '/property/leaseContract/relate',
  // 关联合同列表
  RELATED_CONTRACT_LIST_PAGE: '/property/leaseContract/pageRelateList',
  //片区查询
  GET_AREA: '/property/space/ListByParentIdAndCompanyNo',
  // 获取字典表中的枚举
  DATA_DICT: '/maindata/dictData/listDataDictByDataType',
  /**新增根据公司编码和名称查询*/
  GET_DEPARTMENT_LIST_API: '/maindata/department/listDepartmentPullDown',
  // 根据公司 部门查人员
  GET_USER_LIST_API: '/maindata/userAccount/listUserAccountForApprover',
  // 查角色列表
  GET_ROLE_LIST_API: '/maindata/role/listRolesInfo',
  // 保存租赁合同
  SAVE_LEASE_CONTRACT_API: '/property/leaseContract/save',
  // 编辑租赁合同
  UPDATE_LEASE_CONTRACT_API: '/property/leaseContract/update',
  // 租赁合同详情
  DETAIL_LEASE_CONTRACT_API: '/property/leaseContract',
  // 租赁合同详情通过no
  DETAIL_LEASE_CONTRACT_NO_API: '/property/leaseContract/getByNo',
  // 审批租赁合同
  AUDIT_LEASE_CONTRACT_API: '/property/leaseContract/approval',
  // 详情查看关联合同
  DETAIL_RELATED_CONTRACT: '/property/leaseContract',
  // 取消合同关联
  CANCEL_RELATED_CONTRACT: '/property/leaseContract/relate/cancel',
  // 续签合同
  RENEW_LEASE_CONTRACT: '/property/leaseContract/renew',
  // 变更合同主体
  CHANGE_SUBJECT_LEASE_CONTRACT: '/property/leaseContract/changeSubject',
  // 变更合同信息
  CHANGE_Info_LEASE_CONTRACT: '/property/leaseContract/changeInfo',
  // 导出合同
  EXPORT_CONTRACT_API: '/property/leaseContract/export/v1',
  // 合作伙伴扩展列表
  LIST_PARTNEREXTEND: '/maindata/partners/getPartnerExtendByPage',
  // 根据部门code获取佣金角色
  ROLE_BY_DEPARTMENTCODE: '/property/commissionRule/getRoleByDepartmentCode',
  // 暂停租赁合同
  SUSPEND_LEASE_CONTRACT: '/property/leaseContract/pause',
  // 启用租赁合同
  ENABLE_LEASE_CONTRACT: '/property/leaseContract/enable',
  // 水电表编号
  WATER_ENERGY: '/property/space/energy',
  // 撤回
  RECALL: '/property/leaseContract/recall',
  // 租赁合同删除
  DELETE: '/property/leaseContract/delete',
  // 导入免租期
  IMPORT_PARTNER: '/property/leaseContract/importExcel',
  // 减免历史查询
  HISTORY_QUERY: '/property/leaseContract/reduction/list',
  // 关闭审核合同
  CLOSECONTRACT: '/property/leaseContract/closeCheck',
};
